import queryString from 'query-string';
import { isInApp, isKwaiMe, isSnack } from './device-info';
import { useDetailPageUrl } from '@/page/detail/views/jump';
import { useQuery } from '@/hooks/useQuery';

/**
 * 拉新拉活文档
 * https://docs.corp.kuaishou.com/k/home/VLha5nKins4Y/fcACjeRVeyLIQ2AdmVjo723f_
 * 短链生成工具
 * https://applinksplatform.corp.kuaishou.com/
 */

/**
 * 端外拉活
 * @param args.url 拉端后要跳转的页面
 * @param args.pageId 页面id，拉新，onelink链接生成时需要（onelink链路追踪）
 */
export function useCallApp() {
    const share_id = useQuery('share_id') as string;
    const photoId = useQuery('photoId') as string;
    const callUrl = useDetailPageUrl();

    function callApp(args: { loading?: boolean; pageId: string }) {
        if (isInApp) {
            return;
        }
        const callByOneLink = () => {
            // 生成onelink链接，拼接所需要的参数
            const targetUrl = queryString.stringifyUrl(
                {
                    // url: window.location.href,
                    url: callUrl,
                    query: {
                        shareInfo: null,
                        innerPage: null,
                        share_id,
                        share_item_type: photoId ? 'goods_video' : 'goods',
                    },
                },
                { skipNull: true, sort: false },
            );

            const query = {
                pid: args.pageId,
                is_retargeting: true,
                af_force_deeplink: true,
                land_info: JSON.stringify({
                    linkParams: {
                        primary_directory: 'SHARE',
                        secondary_directory: 'ecomm',
                        link_id: `${args.pageId}_${Date.now()}`,
                        item_type: 'h5_item_type',
                        item_info: args.pageId,
                    },
                }),
                deep_link_sub1: `pid=${args.pageId}`,
                af_dp: `ikwai://webview?url=${encodeURIComponent(targetUrl)}`,
                ug_referrer: `pid=${args.pageId}`,
                deep_link_value: `ikwai://webview?url=${encodeURIComponent(targetUrl)}`,
                // 为onelink追加的参数，用来回流链路追踪
                af_sub1: JSON.stringify({
                    share_id,
                    shareInfo: {
                        target_url: queryString.stringifyUrl(
                            {
                                // url: window.location.href,
                                url: callUrl,
                                query: {
                                    shareInfo: null,
                                    innerPage: null,
                                    share_id,
                                    share_item_type: photoId ? 'goods_video' : 'goods',
                                },
                            },
                            { skipNull: true, sort: false },
                        ),
                    },
                }),
            };

            // onelink工具生成的onelink地址，然后再把参数替换成动态的，https://applinksplatform.corp.kuaishou.com/
            const oneLink = {
                KWAI: queryString.stringifyUrl({ url: 'https://go.onelink.me/iGO2', query }),
                KWAI_ME: queryString.stringifyUrl({ url: 'https://kme.onelink.me/KtRN', query }),
                KWAI_BULLDOG: queryString.stringifyUrl({ url: 'https://sck.onelink.me/UxxP', query }),
            };

            const oneLinkUrl = isSnack ? oneLink.KWAI_BULLDOG : isKwaiMe ? oneLink.KWAI_ME : oneLink.KWAI;

            const data = {
                // 拉活归因链路中必需参数 调起客户端时 客户端会检测链接中是否有target_url参数
                path: queryString.stringifyUrl({
                    url: 'webview',
                    query: {
                        target_url: targetUrl,
                        url: targetUrl,
                    },
                }),
                onelink: oneLinkUrl,
                protocol: isSnack ? 'ikwaibulldog' : 'ikwai',
            };

            window.open(oneLinkUrl);
        };

        callByOneLink();
    }

    return { callApp };
}
